/**
 *Created by Heqi on 2018/1/18.
 */

import { AbstractSearchArgument } from './global'

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.targetId = ''
  }
}

export {
  SearchArgument
}



// WEBPACK FOOTER //
// ./src/models/sub-message.js